// Конфигурация окружения и вспомогательные функции

export const baseURL = import.meta.env.REACT_APP_API_URL || '';
export const usfStage = import.meta.env.REACT_APP_STAGE || 'dev';
export const kcURL = import.meta.env.REACT_APP_KC_URL || '';
export const kcRealm = import.meta.env.REACT_APP_KC_REALM || '';
export const kcClientId = import.meta.env.REACT_APP_KC_CLIENT_ID || '';
export const kcOnLoad = import.meta.env.REACT_APP_KC_ON_LOAD || 'login-required';

/**
 * Принудительно загружает blob как файл
 * @param blob - Массив blob объектов для загрузки
 * @param filename - Имя файла для сохранения
 */
export const forceDownload = (blob: BlobPart[], filename: string): void => {
  const url = window.URL.createObjectURL(new Blob(blob));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  // Освобождаем память
  window.URL.revokeObjectURL(url);
};
